<template>
    <div>
        <input class="align-middle" type="checkbox" v-model="shouldSave" id="shouldSaveCheckbox"/>
        <label class="mb-0 align-middle" for="shouldSaveCheckbox">Save as template</label>
        <div v-if="shouldSave" class="border-top pt-3 d-flex align-items-center">
            <label class="mb-0 align-middle mr-2" for="newLabelText">Enter a label</label>
            <div class="mr-2">
                <input class="form-control align-middle" type="text" v-model="newLabel" id="newLabelText" />
            </div>
            <div>
                <button @click="saveTemplate" class="btn btn-primary">Save</button>
            </div>
        </div>
    </div>
</template>

<script>
import SurveysService from '../../services/surveys-service';
export default {
    props: {
        body: {
            type: String
        }
    },
    data() {
        return {
            shouldSave: false,
            newLabel: ''
        }
    },
    methods: {
        async saveTemplate() {
            const saved = await SurveysService.responseTemplates.create(this.newLabel, this.body);
            if (!saved) {
                swal({
                    title: "Could not send save template",
                    text: data.error,
                    type: "warning",
                    showCloseButton: true,
                    timer: 10000
                });
                return;
            }
            swal({
                title: "Template saved",
                text: 'The template has been saved successfully.',
                type: "success",
                showCloseButton: true,
                timer: 10000
            });
            this.shouldSave = false;
            this.$emit('saved', saved);
        }
    }
}
</script>
